import { render, staticRenderFns } from "./TasksDropdown.vue?vue&type=template&id=1f0cd718&scoped=true"
import script from "./TasksDropdown.vue?vue&type=script&lang=js"
export * from "./TasksDropdown.vue?vue&type=script&lang=js"
import style0 from "./TasksDropdown.vue?vue&type=style&index=0&id=1f0cd718&prod&lang=scss"
import style1 from "./TasksDropdown.vue?vue&type=style&index=1&id=1f0cd718&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0cd718",
  null
  
)

export default component.exports